export default "__VITE_ASSET__BqlZMBr5__$_?format=webp__"